import { render, staticRenderFns } from "./amit.vue?vue&type=template&id=62189cee&scoped=true"
import script from "./amit.vue?vue&type=script&lang=js"
export * from "./amit.vue?vue&type=script&lang=js"
import style0 from "./amit.vue?vue&type=style&index=0&id=62189cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62189cee",
  null
  
)

export default component.exports